/** BLE device configuration for NEENO IMU sensor */
export const BLE_CONFIG = {
  SERVICE_UUID: '19b10000-e8f2-537e-4f6c-d104768a1214',
  CHARACTERISTIC_UUID: '79b10001-e8f2-537e-4f6c-a204768a1215',

  /** Decoder profile — matched in the packet registry */
  DECODER_PROFILE: 'neeno-imu-v1',

  /** Reconnect behaviour */
  RECONNECT_MAX_ATTEMPTS: 5,
  RECONNECT_BASE_DELAY_MS: 1000,
} as const
